'use client';

import { useMemo } from 'react';

import { UiKitCheckboxTag } from '@/fo/ui/kit/checkbox/tag';

import { PointType } from '../../types';

import { styles } from './PointSelector.styles';

export interface PointSelectorProps {
  pointTypes: PointType[];
  selectedPointType: PointType | null;
  onPointTypeChange: (pointType: PointType | null) => void;
  size?: 'small' | 'default';
}

export function PointSelector({
  pointTypes,
  selectedPointType,
  onPointTypeChange,
  size = 'default'
}: PointSelectorProps) {
  const slots = styles({ size });
  const options = useMemo(
    () =>
      pointTypes.map((type) => ({
        label: type,
        value: type
      })),
    [pointTypes]
  );

  return (
    <div className={slots.base()}>
      <div className={slots.tabs()}>
        {options.map((option, index) => (
          <UiKitCheckboxTag
            key={`${option.value}-${index}`}
            onChange={() => {
              onPointTypeChange((option?.value as PointType) || null);
            }}
            checked={option.value === selectedPointType}
            disabled={option.value === selectedPointType}
            label={option.value}
          />
        ))}
      </div>
    </div>
  );
}
